import { createBrowserRouter, Navigate } from 'react-router';
import { DashboardLayout } from './layouts/DashboardLayout';
import { AuthCallback } from './pages/AuthCallback';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/SearchPage';
import { storesRoutes } from './modules/stores/stores.routes';
import { usersRoutes } from './modules/users/users.routes';
import { feedsRoutes } from './modules/feeds/feeds.routes';
import { microappsRoutes } from './modules/microapps/microapps.routes';
import { queriesRoutes } from './modules/queries/queries.routes';
import { checklistsRoutes } from './modules/checklists/checklists.routes';
import { billingRoutes } from './modules/billing/billing.routes';
import { supportRoutes } from './modules/support/support.routes';
import { adminRoutes } from './modules/admin/admin.routes';
import { helpRoutes } from './modules/help/help.routes';

export const router = createBrowserRouter([
  {
    path: '/auth/callback',
    element: <AuthCallback />,
  },
  {
    path: '/',
    element: <DashboardLayout />,
    handle: { breadcrumb: 'Dashboard' },
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'search',
        element: <SearchPage />,
        handle: { breadcrumb: 'Search' },
      },
      // Entity modules
      storesRoutes,
      usersRoutes,

      // Content module (E5)
      feedsRoutes,
      // Analytics redirect → now under /stores/equipment
      { path: 'analytics', element: <Navigate to="/stores/equipment" replace /> },

      // MicroApps & Query Explorer (E7)
      microappsRoutes,
      queriesRoutes,
      checklistsRoutes,

      // Billing (E9)
      billingRoutes,

      supportRoutes,

      adminRoutes,
      helpRoutes,
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
